/* eslint-disable max-len */
const LanguagePackEntries = {
  PREF_CENTER_PROFILE_MAIN_TITLE: {
    languagePackKey: 'pages.pref-center.profile.title',
    fallbackValue: 'Your Profile',
  },
  PREF_CENTER_PROFILE_EMAIL: {
    languagePackKey: 'pages.pref-center.profile.email',
    fallbackValue: 'Email Address',
  },
  PREF_CENTER_PROFILE_UPDATE: {
    languagePackKey: 'pages.pref-center.profile.update',
    fallbackValue: 'Update',
  },
  PREF_CENTER_PROFILE_PASSWORD: {
    languagePackKey: 'pages.pref-center.profile.password',
    fallbackValue: 'Password',
  },
  PREF_CENTER_PROFILE_EMAIL_UPDATE_TITLE: {
    languagePackKey: 'pages.pref-center.profile.email-update-title',
    fallbackValue: 'Update Email Address',
  },
  PREF_CENTER_PROFILE_EMAIL_UPDATE_EMAIL_LABEL: {
    languagePackKey: 'pages.pref-center.profile.email-update-email-label',
    fallbackValue: 'New Email',
  },
  PREF_CENTER_PROFILE_EMAIL_UPDATE_EMAIL_PLACEHOLDER: {
    languagePackKey: 'pages.pref-center.profile.email-update-email-placeholder',
    fallbackValue: 'Enter Email',
  },
  PREF_CENTER_PROFILE_EMAIL_UPDATE_PASSWORD_LABEL: {
    languagePackKey: 'pages.pref-center.profile.email-update-password-label',
    fallbackValue: 'Your Password',
  },
  PREF_CENTER_PROFILE_EMAIL_UPDATE_PASSWORD_PLACEHOLDER: {
    languagePackKey: 'pages.pref-center.profile.email-update-password-placeholder',
    fallbackValue: 'Enter password',
  },
  PREF_CENTER_PROFILE_EMAIL_UPDATE_SAVE: {
    languagePackKey: 'pages.pref-center.profile.email-update-save',
    fallbackValue: 'Save',
  },
  PREF_CENTER_PROFILE_PASSWORD_UPDATE_TITLE: {
    languagePackKey: 'pages.pref-center.profile.password-update-title',
    fallbackValue: 'Update Password',
  },
  PREF_CENTER_PROFILE_PASSWORD_UPDATE_CURRENT_PASSWORD_LABEL: {
    languagePackKey: 'pages.pref-center.profile.password-update-current-password-label',
    fallbackValue: 'Current Password',
  },
  PREF_CENTER_PROFILE_PASSWORD_UPDATE_CURRENT_PASSWORD_PLACEHOLDER: {
    languagePackKey: 'pages.pref-center.profile.password-update-current-password-placeholder',
    fallbackValue: 'Enter your password',
  },
  PREF_CENTER_PROFILE_PASSWORD_UPDATE_NEW_PASSWORD_LABEL: {
    languagePackKey: 'pages.pref-center.profile.password-update-new-password-label',
    fallbackValue: 'New Password',
  },
  PREF_CENTER_PROFILE_PASSWORD_UPDATE_NEW_PASSWORD_PLACEHOLDER: {
    languagePackKey: 'pages.pref-center.profile.password-update-new-password-placeholder',
    fallbackValue: 'Enter a password',
  },
  PREF_CENTER_PROFILE_PASSWORD_UPDATE_SAVE: {
    languagePackKey: 'pages.pref-center.profile.password-update-save',
    fallbackValue: 'Continue',
  },
  PREF_CENTER_PROFILE_PASSWORD_UPDATE_STEP_2_TITLE: {
    languagePackKey: 'pages.pref-center.profile.password-update-step-2-title',
    fallbackValue: 'Reset your password',
  },
  PREF_CENTER_PROFILE_EMAIL_UPDATE_STEP_2_TITLE: {
    languagePackKey: 'pages.pref-center.profile.email-update-step-2-title',
    fallbackValue: 'Update Email Address',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_MESSAGE_SENT: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-message-sent',
    fallbackValue: 'A message with a code has been sent to email address:',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_ENTER_CODE: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-enter-code',
    fallbackValue: 'Enter the code in the box below.',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_RESEND_CODE_LINK_TEXT: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-resend-code-link-text',
    fallbackValue: 'Didn\'t get a code?',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_CODE_LABEL: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-code-label',
    fallbackValue: 'Code',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_CODE_PLACEHOLDER: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-code-placeholder',
    fallbackValue: 'e.g. 350271',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_SAVE: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-save',
    fallbackValue: 'Submit',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_NEW_CODE_MODAL_TITLE: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-new-code-modal-title',
    fallbackValue: 'Get a new verification code',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_NEW_CODE_MODAL_BODY: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-new-code-modal-body',
    fallbackValue: 'Would you like to send a new verification code to',
  },
  PREF_CENTER_PROFILE_UPDATE_STEP_2_NEW_CODE_MODAL_BUTTON: {
    languagePackKey: 'pages.pref-center.profile.update-step-2-new-code-modal-button',
    fallbackValue: 'Resend Code',
  },
  PREF_CENTER_PROFILE_UPDATE_RETURN_TEXT: {
    languagePackKey: 'pages.pref-center.profile.update-return-text',
    fallbackValue: 'Return to Personal Information',
  },
  PREF_CENTER_PROFILE_ATTRIBUTES_UPDATE_TITLE: {
    languagePackKey: 'pages.pref-center.profile.attributes-update-title',
    fallbackValue: 'Your profile',
  },
  PREF_CENTER_PROFILE_ATTRIBUTES_UPDATE_SELECT_LIST_PLACEHOLDER: {
    languagePackKey: 'pages.pref-center.profile.attributes-select-list-placeholder',
    fallbackValue: 'Select One',
  },
  PREF_CENTER_PROFILE_ATTRIBUTES_UPDATE_SAVE: {
    languagePackKey: 'pages.pref-center.profile.attributes-update-save',
    fallbackValue: 'Save',
  },
  PREF_CENTER_PROFILE_ERRORS_UNSUCCESSFUL: {
    languagePackKey: 'pages.pref-center.profile.errors.unsuccessful',
    fallbackValue: 'Unsuccessful',
  },
  PREF_CENTER_PROFILE_ERRORS_INCORRECT_PASSWORD: {
    languagePackKey: 'pages.pref-center.profile.errors.incorrect-password',
    fallbackValue: 'The password you entered is incorrect',
  },
  PREF_CENTER_PROFILE_ERRORS_UPDATE_PROFILE_ERROR: {
    languagePackKey: 'pages.pref-center.profile.errors.update-profile-error',
    fallbackValue: 'Sorry but we were unable to update your profile. Please try again.',
  },
  PREF_CENTER_PROFILE_ERRORS_CHANGE_EMAIL_ERROR: {
    languagePackKey: 'pages.pref-center.profile.errors.change-email-error',
    fallbackValue: 'Sorry but your email address has not been changed. Please try again.',
  },
  PREF_CENTER_PROFILE_ERRORS_PASSWORD_VALIDATION_ERROR: {
    languagePackKey: 'pages.pref-center.profile.errors.password-validation-error',
    fallbackValue: 'Password is not strong enough',
  },
  PREF_CENTER_PROFILE_ERRORS_CHANGE_PASSWORD_ERROR: {
    languagePackKey: 'pages.pref-center.profile.errors.change-password-error',
    fallbackValue: 'Sorry but we were unable to reset your password. Please try again.',
  },
  PREF_CENTER_PROFILE_ERRORS_INCORRECT_CODE: {
    languagePackKey: 'pages.pref-center.profile.errors.incorrect-code',
    fallbackValue: 'Entered code is incorrect',
  },
  PREF_CENTER_PROFILE_ERRORS_EMAIL_ALREADY_TAKEN_ERROR: {
    languagePackKey: 'pages.pref-center.profile.errors.email-already-taken-error',
    fallbackValue: 'This email address is already taken.',
  },
  PREF_CENTER_PROFILE_UPDATE_SUCCESSFUL: {
    languagePackKey: 'pages.pref-center.profile.update-successful',
    fallbackValue: 'Success',
  },
  PREF_CENTER_PROFILE_UPDATE_EMAIL_SUCCESSFUL: {
    languagePackKey: 'pages.pref-center.profile.update-email-successful',
    fallbackValue: 'Your email address has been changed.',
  },
  PREF_CENTER_PROFILE_UPDATE_PASSWORD_SUCCESSFUL: {
    languagePackKey: 'pages.pref-center.profile.update-password-successful',
    fallbackValue: 'Your password has been reset.',
  },
  PREF_CENTER_PROFILE_UPDATE_PROFILE_SUCCESSFUL: {
    languagePackKey: 'pages.pref-center.profile.update-profile-successful',
    fallbackValue: 'Your profile has been updated.',
  },
  PREF_CENTER_SHARED_PRODUTCS_SHARED_BY: {
    languagePackKey: 'pages.pref-center.shared-products.shared-by',
    fallbackValue: 'Shared by',
  },
  PREF_CENTER_SHARED_PRODUTCS_REMOVE_SUBSCRIPTION: {
    languagePackKey: 'pages.pref-center.shared-products.remove-subscription',
    fallbackValue: 'Leave shared subscription',
  },
  PREF_CENTER_SHARED_PRODUTCS_NO_SUBSCRIPTIONS: {
    languagePackKey: 'pages.pref-center.shared-products.no-subscriptions',
    fallbackValue: 'You do not currently have any products shared with you.',
  },
  PREF_CENTER_SHARED_PRODUTCS_LEAVE_PRODUCT_TITLE: {
    languagePackKey: 'pages.pref-center.shared-products.leave-product-title',
    fallbackValue: 'Leave Product',
  },
  PREF_CENTER_SHARED_PRODUTCS_REMOVE_INVITE_TITLE: {
    languagePackKey: 'pages.pref-center.shared-products.remove-invite-title',
    fallbackValue: 'Remove Invite',
  },
  PREF_CENTER_SHARED_PRODUTCS_REMOVE_MEMBER_TITLE: {
    languagePackKey: 'pages.pref-center.shared-products.remove-member-title',
    fallbackValue: 'Remove Member',
  },
  PREF_CENTER_SHARED_PRODUTCS_LEAVE_PRODUCT_BODY: {
    languagePackKey: 'pages.pref-center.shared-products.leave-product-body',
    fallbackValue: 'Are you sure you want to leave this shared product?',
  },
  PREF_CENTER_SHARED_PRODUTCS_REMOVE_INVITE_BODY: {
    languagePackKey: 'pages.pref-center.shared-products.remove-invite-body',
    fallbackValue: 'Are you sure you want to remove this pending invite from your subscription?',
  },
  PREF_CENTER_SHARED_PRODUTCS_REMOVE_MEMBER_BODY: {
    languagePackKey: 'pages.pref-center.shared-products.remove-member-body',
    fallbackValue: 'Are you sure you want to remove this user from your subscription?',
  },
  PREF_CENTER_MANAGE_SHARED_MEMBERS_TITLE: {
    languagePackKey: 'pages.pref-center.shared-members.manage-shared-members-title',
    fallbackValue: 'Manage shared members',
  },
  PREF_CENTER_SHARED_MEMBERS_TITLE: {
    languagePackKey: 'pages.pref-center.shared-members.title',
    fallbackValue: 'Shared Members',
  },
  PREF_CENTER_SHARED_MEMBERS_STATUS_ACTIVE: {
    languagePackKey: 'pages.pref-center.shared-members.status-active',
    fallbackValue: 'Active',
  },
  PREF_CENTER_SHARED_MEMBERS_STATUS_PENDING: {
    languagePackKey: 'pages.pref-center.shared-members.status-pending',
    fallbackValue: 'Pending',
  },
  PREF_CENTER_SHARED_MEMBERS_STATUS_INACTIVE: {
    languagePackKey: 'pages.pref-center.shared-members.status-inactive',
    fallbackValue: 'Inactive',
  },
  PREF_CENTER_SHARED_MEMBERS_SEATS_USED: {
    languagePackKey: 'pages.pref-center.shared-members.seats-used',
    fallbackValue: 'seats used',
  },
  PREF_CENTER_SHARED_MEMBERS_INVITE_BUTTON_TEXT: {
    languagePackKey: 'pages.pref-center.shared-members.invite-button-text',
    fallbackValue: 'Invite new members',
  },
  PREF_CENTER_SHARED_MEMBERS_TABLE_HEADER_EMAIL: {
    languagePackKey: 'pages.pref-center.shared-members.table-header-email',
    fallbackValue: 'Email Address',
  },
  PREF_CENTER_SHARED_MEMBERS_TABLE_HEADER_STATUS: {
    languagePackKey: 'pages.pref-center.shared-members.table-header-status',
    fallbackValue: 'Status',
  },
  PREF_CENTER_SHARED_MEMBERS_TABLE_HEADER_DATE: {
    languagePackKey: 'pages.pref-center.shared-members.table-header-date',
    fallbackValue: 'Date Shared',
  },
  PREF_CENTER_SHARED_MEMBERS_TABLE_REMOVE_MEMBER: {
    languagePackKey: 'pages.pref-center.shared-members.table-remove-member',
    fallbackValue: 'Remove member',
  },
  PREF_CENTER_SHARED_MEMBERS_NO_MEMBERS: {
    languagePackKey: 'pages.pref-center.shared-members.no-members',
    fallbackValue: 'This product is not currently shared with anyone.',
  },
  PREF_CENTER_SHARED_MEMBERS_DONE_BUTTON: {
    languagePackKey: 'pages.pref-center.shared-members.done-button',
    fallbackValue: 'Done',
  },
  PREF_CENTER_SHARE_PRODUCT_MODAL_TITLE: {
    languagePackKey: 'pages.pref-center.share-product.modal-title',
    fallbackValue: 'Invite people to your sharable subscription',
  },
  PREF_CENTER_SHARE_PRODUCT_MODAL_BODY: {
    languagePackKey: 'pages.pref-center.share-product.modal-body',
    fallbackValue: 'You can invite people by entering their email. Available seats: ',
  },
  PREF_CENTER_SHARE_PRODUCT_MODAL_EMAIL_LABEL: {
    languagePackKey: 'pages.pref-center.share-product.modal-email-label',
    fallbackValue: 'Email Address',
  },
  PREF_CENTER_SHARE_PRODUCT_MODAL_EMAIL_PLACEHOLDER: {
    languagePackKey: 'pages.pref-center.share-product.modal-email-placeholder',
    fallbackValue: 'Enter Email Address',
  },
  PREF_CENTER_SHARE_PRODUCT_MODAL_SEND_BUTTON_TEXT: {
    languagePackKey: 'pages.pref-center.share-product.modal-send-button-text',
    fallbackValue: 'Send Invite',
  },
  PREF_CENTER_SHARED_PRODUCTS_ERRORS_NO_ACCESS_ERROR: {
    languagePackKey: 'pages.pref-center.shared-products.errors.no-access-error',
    fallbackValue: 'You do not currently have access to this product',
  },
  PREF_CENTER_SHARED_PRODUCTS_ERRORS_INVALID_EMAIL_ERROR: {
    languagePackKey: 'pages.pref-center.shared-products.errors.invalid-email-error',
    fallbackValue: 'Invalid email address',
  },
  PREF_CENTER_SHARED_PRODUCTS_ERRORS_LIMIT_REACHED_ERROR: {
    languagePackKey: 'pages.pref-center.shared-products.errors.limit-reached-error',
    fallbackValue: 'You have reached the sharing limit for this product',
  },
  PREF_CENTER_SHARED_PRODUCTS_ERRORS_EXISTING_INVITE_ERROR: {
    languagePackKey: 'pages.pref-center.shared-products.errors.existing-invite-error',
    fallbackValue: 'An invite has already been created for this email',
  },
  PREF_CENTER_GENERAL_ERROR: {
    languagePackKey: 'pages.pref-center.general-error',
    fallbackValue: 'Something went wrong - please try again later',
  },
  PREF_CENTER_SUBSCRIPTIONS_PRODUCT_CANCELED: {
    languagePackKey: 'pages.pref-center.subscriptions.product-canceled',
    fallbackValue: 'Product canceled',
  },
  PREF_CENTER_SUBSCRIPTIONS_ONE_OFF_EXPIRY_DATE: {
    languagePackKey: 'pages.pref-center.subscriptions.one-off-expiry-date',
    fallbackValue: 'Expiry Date',
  },
  PREF_CENTER_SUBSCRIPTIONS_PAYMENT_INFORMATION_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.payment-information-title',
    fallbackValue: 'Payment Information',
  },
  PREF_CENTER_SUBSCRIPTIONS_INVOICES_TEXT: {
    languagePackKey: 'pages.pref-center.subscriptions.invoices-text',
    fallbackValue: 'To see previous invoices visit',
  },
  PREF_CENTER_SUBSCRIPTIONS_BILLING_HISTORY_LINK: {
    languagePackKey: 'pages.pref-center.subscriptions.billing-history-link',
    fallbackValue: 'Billing History.',
  },
  PREF_CENTER_SUBSCRIPTIONS_BILLING_HISTORY_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.billing-history-title',
    fallbackValue: 'Billing History',
  },
  PREF_CENTER_SUBSCRIPTIONS_BILLING_HISTORY_TABLE_HEADER_DATE: {
    languagePackKey: 'pages.pref-center.subscriptions.billing-history-table-header-date',
    fallbackValue: 'Date',
  },
  PREF_CENTER_SUBSCRIPTIONS_BILLING_HISTORY_TABLE_HEADER_PERIOD: {
    languagePackKey: 'pages.pref-center.subscriptions.billing-history-table-header-period',
    fallbackValue: 'Subscription Period',
  },
  PREF_CENTER_SUBSCRIPTIONS_BILLING_HISTORY_TABLE_HEADER_SUBTOTAL: {
    languagePackKey: 'pages.pref-center.subscriptions.billing-history-table-header-subtotal',
    fallbackValue: 'Subtotal',
  },
  PREF_CENTER_SUBSCRIPTIONS_BILLING_HISTORY_TABLE_HEADER_TOTAL: {
    languagePackKey: 'pages.pref-center.subscriptions.billing-history-table-header-total',
    fallbackValue: 'Total',
  },
  PREF_CENTER_SUBSCRIPTIONS_BILLING_HISTORY_TABLE_CANCELED: {
    languagePackKey: 'pages.pref-center.subscriptions.billing-history-table-canceled',
    fallbackValue: 'Subscription canceled',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_PAYMENT_METHOD_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-payment-method-title',
    fallbackValue: 'Change payment method',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_PAYMENT_METHOD_DESCRIPTION: {
    languagePackKey: 'pages.pref-center.subscriptions.change-payment-method-description',
    fallbackValue: 'Adjust how you pay for the product.',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_PAYMENT_METHOD_SCREEN_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-payment-method-screen-title',
    fallbackValue: 'Enter Payment Detail',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_PAYMENT_METHOD_SCREEN_DESCRIPTION: {
    languagePackKey: 'pages.pref-center.subscriptions.change-payment-method-screen-description',
    fallbackValue: 'This credit card will be used as the payment method for the following subscription:',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_PAYMENT_METHOD_SCREEN_SAVE_BUTTON: {
    languagePackKey: 'pages.pref-center.subscriptions.change-payment-method-screen-save-button',
    fallbackValue: 'Save',
  },
  PREF_CENTER_SUBSCRIPTIONS_RETURN_TO_SUBSCRIPTIONS_TEXT: {
    languagePackKey: 'pages.pref-center.subscriptions.return-to-subscriptions-text',
    fallbackValue: 'Return to Subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_RETURN_TO_SUBSCRIPTION_TEXT: {
    languagePackKey: 'pages.pref-center.subscriptions.return-to-subscription-text',
    fallbackValue: 'Return to Subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_UPDATE_SUCCESS: {
    languagePackKey: 'pages.pref-center.subscriptions.update-success',
    fallbackValue: 'Update success',
  },
  PREF_CENTER_SUBSCRIPTIONS_NEXT_PAYMENT_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.next-payment-title',
    fallbackValue: 'Next payment date',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCELED_DATE: {
    languagePackKey: 'pages.pref-center.subscriptions.canceled-date',
    fallbackValue: 'Canceled on',
  },
  PREF_CENTER_SUBSCRIPTIONS_SUBSCRIPTION_RATE_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.subscription-rate-title',
    fallbackValue: 'Subscription rate',
  },
  PREF_CENTER_SUBSCRIPTIONS_ONE_OFF_PRICE_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.one-off-price-title',
    fallbackValue: 'Price',
  },
  PREF_CENTER_SUBSCRIPTIONS_PAYMENT_PROCESSING_TEXT: {
    languagePackKey: 'pages.pref-center.subscriptions.payment-processing-text',
    fallbackValue: '(payment processing)',
  },
  PREF_CENTER_SUBSCRIPTIONS_MANAGE_SINGLE_SUBSCRIPTION_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.manage-single-subscription-title',
    fallbackValue: 'Manage Subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-title',
    fallbackValue: 'Change your subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SUBSCRIPTION_DESCRIPTION: {
    languagePackKey: 'pages.pref-center.subscriptions.change-subscription-description',
    fallbackValue: 'Adjust what products you have access to.',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-title',
    fallbackValue: 'Manage Subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_CURRENT_SUBSCRIPTION_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-current-subscription-title',
    fallbackValue: 'Current Subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_NEW_SUBSCRIPTION_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-new-subscription-title',
    fallbackValue: 'Change Subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_NEW_SUBSCRIPTION_DESCRIPTION: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-new-subscription-description',
    fallbackValue: 'Change your current subscription for another.',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_PAYMEMT_METHOD_SELECTION: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-payment-method-selection',
    fallbackValue: 'Payment Method',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_EXISTING_PAYMEMT: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-existing-payment',
    fallbackValue: 'Use existing payment method',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_ADD_NEW: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-add-new',
    fallbackValue: 'Add a new card',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_CONFIRM_BUTTON: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-confirm-button',
    fallbackValue: 'CONFIRM & PROCESS PAYMENT',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_REVIEW_BUTTON: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-review-button',
    fallbackValue: 'Review Changes',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_BEST_VALUE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-best-value',
    fallbackValue: 'Best Value',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_SELECT_PLAN: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-select-plan',
    fallbackValue: 'Select Plan',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SINGLE_SUBSCRIPTION_SCREEN_SELECTED_PLAN: {
    languagePackKey: 'pages.pref-center.subscriptions.change-single-subscription-screen-selected-plan',
    fallbackValue: 'Selected Plan',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCEL_SUBSCRIPTION_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.cancel-subscription-title',
    fallbackValue: 'Cancel your subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCEL_SUBSCRIPTION_MODAL_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.cancel-subscription-modal-title',
    fallbackValue: 'Cancel your subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCEL_SUBSCRIPTION_MODAL_BODY: {
    languagePackKey: 'pages.pref-center.subscriptions.cancel-subscription-modal-body',
    fallbackValue: 'Are you sure you want to cancel the subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCEL_SUBSCRIPTION_MODAL_BUTTON: {
    languagePackKey: 'pages.pref-center.subscriptions.cancel-subscription-modal-button',
    fallbackValue: 'Cancel Subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCEL_SUBSCRIPTION_CONFIRM_MODAL_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.cancel-subscription-confirm-modal-title',
    fallbackValue: 'Subscription canceled',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCEL_SUBSCRIPTION_CONFIRM_MODAL_BODY: {
    languagePackKey: 'pages.pref-center.subscriptions.cancel-subscription-confirm-modal-body',
    fallbackValue: 'Your subscription has been canceled.',
  },
  PREF_CENTER_SUBSCRIPTIONS_CANCEL_SUBSCRIPTION_CONFIRM_MODAL_BUTTON: {
    languagePackKey: 'pages.pref-center.subscriptions.cancel-subscription-confirm-modal-button',
    fallbackValue: 'Close',
  },
  PREF_CENTER_SUBSCRIPTIONS_NO_SUBSCRIPTIONS: {
    languagePackKey: 'pages.pref-center.subscriptions.no-subscriptions',
    fallbackValue: 'You don\'t have any subscriptions.',
  },
  PREF_CENTER_SUBSCRIPTIONS_MANAGE_SUBSCRIPTIONS_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.manage-subscriptions-title',
    fallbackValue: 'Manage Subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_SUBSCRIPTIONS_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-subscriptions-title',
    fallbackValue: 'Change your subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-title',
    fallbackValue: 'Manage Subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_CURRENT_SUBSCRIPTIONS_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-current-subscriptions-title',
    fallbackValue: 'Current Subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_NEW_SUBSCRIPTIONS_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-new-subscriptions-title',
    fallbackValue: 'New Subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_EDIT_SUBSCRIPTION_TEXT: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-edit-subscription-text',
    fallbackValue: 'Edit',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_BEST_VALUE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-best-value',
    fallbackValue: 'best value',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_CURRENT_SUBSCRIPTION: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-current-subscription',
    fallbackValue: 'current subscription',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_ACTIVE_SUBSCRIPTION: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-active-subscription',
    fallbackValue: 'active',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_CANCEL_SUBSCRIPTIONS_TEXT: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-cancel-subscriptions-text',
    fallbackValue: 'Cancel Subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_CANCEL_SUBSCRIPTIONS_MODAL_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-cancel-subscriptions-modal-title',
    fallbackValue: 'Cancel your subscriptions',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_CANCEL_SUBSCRIPTIONS_CONFIRM_MODAL_TITLE: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-cancel-subscriptions-confirm-modal-title',
    fallbackValue: 'Subscriptions canceled',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_CANCEL_SUBSCRIPTIONS_CONFIRM_MODAL_BODY: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-cancel-subscriptions-confirm-modal-body',
    fallbackValue: 'Your subscriptions have been canceled.',
  },
  PREF_CENTER_SUBSCRIPTIONS_CHANGE_MULTI_SUBSCRIPTION_SCREEN_REVIEW_BUTTON: {
    languagePackKey: 'pages.pref-center.subscriptions.change-multi-subscription-screen-review-button',
    fallbackValue: 'Review Changes',
  },
  PREF_CENTER_SUBSCRIPTIONS_RATE_PLAN: {
    languagePackKey: 'pages.pref-center.subscriptions.rate-plan',
    fallbackValue: 'Rate Plan',
  },
  PREF_CENTER_SUBSCRIPTIONS_RATE_PLAN_CHARGES: {
    languagePackKey: 'pages.pref-center.subscriptions.rate-plan-charges',
    fallbackValue: 'Rate Plan Charges',
  },
  PREF_CENTER_DEVICES_TITLE: {
    languagePackKey: 'pages.pref-center.devices.title',
    fallbackValue: 'Your Devices',
  },
  PREF_CENTER_DEVICES_CURRENT_DEVICE: {
    languagePackKey: 'pages.pref-center.devices.current-device',
    fallbackValue: 'Current Device',
  },
  PREF_CENTER_DEVICES_UNKNOWN_DEVICE: {
    languagePackKey: 'pages.pref-center.devices.unknown-device',
    fallbackValue: 'Unknown',
  },
  PREF_CENTER_DEVICES_SIGN_IN_TIME: {
    languagePackKey: 'pages.pref-center.devices.sign-in-time',
    fallbackValue: 'Login date and time:',
  },
  PREF_CENTER_DEVICES_SIGN_OUT: {
    languagePackKey: 'pages.pref-center.devices.sign-out',
    fallbackValue: 'Sign out',
  },
  PREF_CENTER_DEVICES_SIGN_OUT_ALL: {
    languagePackKey: 'pages.pref-center.devices.sign-out-all',
    fallbackValue: 'Sign out of all other devices',
  },
  PREF_CENTER_DEVICES_SIGN_OUT_SUCCESS: {
    languagePackKey: 'pages.pref-center.devices.sign-out-success',
    fallbackValue: 'is now signed out.',
  },
  PREF_CENTER_DEVICES_SIGN_OUT_ALL_SUCCESS: {
    languagePackKey: 'pages.pref-center.devices.sign-out-all-success',
    fallbackValue: 'All other devices are now signed out',
  },
  PREF_CENTER_DEVICES_SIGN_OUT_FAIL: {
    languagePackKey: 'pages.pref-center.devices.sign-out-fail',
    fallbackValue: 'Signing out failed',
  },
  COMMON_LOADING: {
    languagePackKey: 'pages.common.loading',
    fallbackValue: 'Loading...',
  },
  PREF_CENTER_DEVICES_ERROR_LOADING: {
    languagePackKey: 'pages.pref-center.devices.error-loading',
    fallbackValue: 'There was an error getting the device list',
  },
  LOGIN_EMAIL_PLACEHOLDER: {
    languagePackKey: 'pages.login-reg.email-placeholder',
    fallbackValue: 'Email Address',
  },
  LOGIN_PASSWORD_PLACEHOLDER: {
    languagePackKey: 'pages.login-reg.password-placeholder',
    fallbackValue: 'Password',
  },
  LOGIN_LOGIN_TO_ACCOUNT: {
    languagePackKey: 'pages.login-reg.login-to-account',
    fallbackValue: 'Login to your account',
  },
  LOGIN_REGISTER_FOR_ACCOUNT: {
    languagePackKey: 'pages.login-reg.register-for-account',
    fallbackValue: 'Register for an account',
  },
  LOGIN_RESET_YOUR_PASSWORD: {
    languagePackKey: 'pages.login-reg.reset-your-password',
    fallbackValue: 'Reset your password',
  },
  LOGIN_FORGOTTEN_PASSWORD: {
    languagePackKey: 'pages.login-reg.forgotten-password',
    fallbackValue: 'Forgotten Password?',
  },
  LOGIN_CREATE_ACCOUNT: {
    languagePackKey: 'pages.login-reg.create-account',
    fallbackValue: 'Create an account',
  },
  LOGIN_LOGIN_BUTTON: {
    languagePackKey: 'pages.login-reg.login-button',
    fallbackValue: 'Login',
  },
  LOGIN_COMPLETE_REGISTRATION_BUTTON: {
    languagePackKey: 'pages.login-reg.complete-registration-button',
    fallbackValue: 'Complete Registration',
  },
  LOGIN_REGISTER_BUTTON: {
    languagePackKey: 'pages.login-reg.register-button',
    fallbackValue: 'Register',
  },
  LOGIN_EMAIL_ME_LOGIN_LINK: {
    languagePackKey: 'pages.login-reg.email-me-login-link',
    fallbackValue: 'Email me login link',
  },
  LOGIN_EMAIL_ME_RESET_CODE: {
    languagePackKey: 'pages.login-reg.email-me-reset-code',
    fallbackValue: 'Email me reset code',
  },
  LOGIN_OR: {
    languagePackKey: 'pages.login-reg.or',
    fallbackValue: 'Or',
  },
  LOGIN_CONTINUE_WITH_OPEN_ID_CONNECT: {
    languagePackKey: 'pages.login-reg.continue-with-open-id-connect',
    fallbackValue: 'Continue with Open ID Connect',
  },
  LOGIN_CONTINUE_WITH_GOOGLE: {
    languagePackKey: 'pages.login-reg.continue-with-google',
    fallbackValue: 'Continue with Google',
  },
  LOGIN_CONTINUE_WITH_FACEBOOK: {
    languagePackKey: 'pages.login-reg.continue-with-facebook',
    fallbackValue: 'Continue with Facebook',
  },
  LOGIN_CONTINUE_WITH_APPLE: {
    languagePackKey: 'pages.login-reg.continue-with-apple',
    fallbackValue: 'Continue with Apple',
  },
  LOGIN_CONTINUE_WITH_LINKEDIN: {
    languagePackKey: 'pages.login-reg.continue-with-linkedin',
    fallbackValue: 'Continue with Linkedin',
  },
  LOGIN_CONTINUE_WITH_MICROSOFT: {
    languagePackKey: 'pages.login-reg.continue-with-microsoft',
    fallbackValue: 'Continue with Microsoft',
  },
  LOGIN_CONTINUE_WITH_TWITTER: {
    languagePackKey: 'pages.login-reg.continue-with-twitter',
    fallbackValue: 'Continue with Twitter',
  },
  LOGIN_ALREADY_REGISTERED_SIGN_IN: {
    languagePackKey: 'pages.login-reg.already-registered-sign-in',
    fallbackValue: 'Already registered? Sign in',
  },
  LOGIN_CANCEL: {
    languagePackKey: 'pages.login-reg.cancel',
    fallbackValue: 'Cancel',
  },
  LOGIN_ENTER_ACCOUNT_REG_COD_HERE: {
    languagePackKey: 'pages.login-reg.enter-account-reg-code-here',
    fallbackValue: 'Enter an account registration code here',
  },
  LOGIN_PASSWORD_REQUIREMENT: {
    languagePackKey: 'pages.login-reg.password-requirement',
    // eslint-disable-next-line max-len
    fallbackValue: 'Password must be a minimum of 8 characters and contain uppercase and lowercase, numbers and at least 1 special character.',
  },
  LOGIN_LOGGING_IN: {
    languagePackKey: 'pages.login-reg.logging-in',
    fallbackValue: 'Logging in...',
  },
  LOGIN_WAIT: {
    languagePackKey: 'pages.login-reg.wait',
    fallbackValue: 'Please wait...',
  },
  LOGIN_ERRORS_USERNAME_ALREADY_TAKEN: {
    languagePackKey: 'pages.login-reg.errors.username-already-taken',
    fallbackValue: 'Username already taken',
  },
  LOGIN_ERRORS_EMAIL_ALREADY_TAKEN: {
    languagePackKey: 'pages.login-reg.errors.email-already-taken',
    fallbackValue: 'Email already taken',
  },
  LOGIN_ERRORS_CONTACT_ADMIN: {
    languagePackKey: 'pages.login-reg.errors.contact-admin',
    fallbackValue: 'Please contact the administrator',
  },
  LOGIN_ERRORS_SEAT_CAPACITY: {
    languagePackKey: 'pages.login-reg.errors.seat-capacity',
    fallbackValue: 'Your registration request couldn’t be completed due to account seat capacity issue.',
  },
  LOGIN_ERRORS_EMAIL_VERIFICATION_REQUIRED: {
    languagePackKey: 'pages.login-reg.errors.email-verification-required',
    fallbackValue: 'Email verification is required',
  },
  LOGIN_ERRORS_PASSWORD_INCORRECT: {
    languagePackKey: 'pages.login-reg.errors.password-incorrect',
    fallbackValue: 'The password you entered is incorrect',
  },
  LOGIN_ERRORS_PASSWORD_NOT_STRONG_ENOUGH: {
    languagePackKey: 'pages.login-reg.errors.password-not-strong-enough',
    fallbackValue: 'Password is not strong enough',
  },
  LOGIN_ERRORS_SOMETHING_WENT_WRONG: {
    languagePackKey: 'pages.login-reg.errors.something-went-wrong',
    fallbackValue: 'Something went wrong!',
  },
  LOGIN_ERRORS_TRY_AGAIN_LATER: {
    languagePackKey: 'pages.login-reg.errors.try-again-later',
    fallbackValue: 'Please try again later.',
  },
  LOGIN_ERRORS_USER_NOT_FOUND: {
    languagePackKey: 'pages.login-reg.errors.user-not-found',
    fallbackValue: 'User not found',
  },
  LOGIN_ERRORS_TO_GAIN_ACCESS_CONTACT_ADMIN: {
    languagePackKey: 'pages.login-reg.errors.to-gain-access-contact-admin',
    fallbackValue: 'To gain login access, please contact your administrator',
  },
  ACCOUNT_MANAGEMENT_ERRORS_DELETE_FAIL: {
    languagePackKey: 'pages.account-management.errors.delete-fail',
    fallbackValue: 'Failed to delete',
  },
  ACCOUNT_MANAGEMENT_ERRORS_INVITE_FAIL: {
    languagePackKey: 'pages.account-management.errors.invite-fail',
    fallbackValue: 'Could not invite user:',
  },
  ACCOUNT_MANAGEMENT_ERRORS_ALREADY_EXISTS: {
    languagePackKey: 'pages.account-management.errors.already-exists',
    fallbackValue: 'already exists',
  },
  ACCOUNT_MANAGEMENT_TITLE: {
    languagePackKey: 'pages.account-management.title',
    fallbackValue: 'Manage Your Users',
  },
  ACCOUNT_MANAGEMENT_ACCOUNT_SELECT_DROPDOWN: {
    languagePackKey: 'pages.account-management.account-select-dropdown',
    fallbackValue: 'Select account',
  },
  ACCOUNT_MANAGEMENT_INVITE_BUTTON_TEXT: {
    languagePackKey: 'pages.account-management.invite-button-text',
    fallbackValue: 'Invite a User',
  },
  ACCOUNT_MANAGEMENT_SEARCH_PLACEHOLDER_TEXT: {
    languagePackKey: 'pages.account-management.search-placeholder-text',
    fallbackValue: 'Search for a user',
  },
  ACCOUNT_MANAGEMENT_SEARCH_BUTTON_TEXT: {
    languagePackKey: 'pages.account-management.search-button-text',
    fallbackValue: 'Search',
  },
  ACCOUNT_MANAGEMENT_OWNER: {
    languagePackKey: 'pages.account-management.owner',
    fallbackValue: 'Owner',
  },
  ACCOUNT_MANAGEMENT_DELETE_LINK: {
    languagePackKey: 'pages.account-management.delete-link',
    fallbackValue: 'Delete',
  },
  ACCOUNT_MANAGEMENT_NO_USERS: {
    languagePackKey: 'pages.account-management.no-users',
    fallbackValue: 'No users found',
  },
  ACCOUNT_MANAGEMENT_DELETE_MODAL_TITLE: {
    languagePackKey: 'pages.account-management.delete-modal-title',
    fallbackValue: 'You are about to delete user',
  },
  ACCOUNT_MANAGEMENT_DELETE_MODAL_BODY: {
    languagePackKey: 'pages.account-management.delete-modal-body',
    fallbackValue: 'Are you sure you want to delete this user?',
  },
  ACCOUNT_MANAGEMENT_DELETE_MODAL_BUTTON: {
    languagePackKey: 'pages.account-management.delete-modal-button',
    fallbackValue: 'Yes Delete',
  },
  ACCOUNT_MANAGEMENT_DELETE_SUCCESS_MODAL_TITLE: {
    languagePackKey: 'pages.account-management.delete-success-modal-title',
    fallbackValue: 'User Deleted',
  },
  ACCOUNT_MANAGEMENT_DELETE_SUCCESS_MODAL_BODY: {
    languagePackKey: 'pages.account-management.delete-success-modal-body',
    fallbackValue: 'has been sucessfully deleted.',
  },
  ACCOUNT_MANAGEMENT_SUCCESS_MODAL_BUTTON: {
    languagePackKey: 'pages.account-management.success-modal-button',
    fallbackValue: 'Close',
  },
  ACCOUNT_MANAGEMENT_INVITE_MODAL_TITLE: {
    languagePackKey: 'pages.account-management.invite-modal-title',
    fallbackValue: 'Invite User',
  },
  ACCOUNT_MANAGEMENT_INVITE_MODAL_CONFIRM_BUTTON: {
    languagePackKey: 'pages.account-management.invite-modal-confirm-button',
    fallbackValue: 'Invite User',
  },
  ACCOUNT_MANAGEMENT_INVITE_MODAL_CANCEL_BUTTON: {
    languagePackKey: 'pages.account-management.invite-modal-cancel-button',
    fallbackValue: 'Cancel',
  },
  ACCOUNT_MANAGEMENT_INVITE_MODAL_EMAIL_LABEL: {
    languagePackKey: 'pages.account-management.invite-modal-email-label',
    fallbackValue: 'Email Address',
  },
  ACCOUNT_MANAGEMENT_INVITE_MODAL_EMAIL_PLACEHOLDER: {
    languagePackKey: 'pages.account-management.invite-modal-email-placeholder',
    fallbackValue: 'Enter Email Address',
  },
  ACCOUNT_MANAGEMENT_INVITE_SUCCESS_MODAL_BODY: {
    languagePackKey: 'pages.account-management.invite-success-modal-body',
    fallbackValue: 'An invite has been sent to',
  },
  CANCEL_CANCEL_SUBSCRIPTION: {
    languagePackKey: 'pages.cancel.cancel-subscription',
    fallbackValue: 'Cancel Subscription',
  },
  CANCEL_SELECT_PLANS: {
    languagePackKey: 'pages.cancel.select-plans',
    fallbackValue: 'Select the plans you wish to cancel',
  },
  CANCEL_SUBSCRIPTION_ENDS_ON: {
    languagePackKey: 'pages.cancel.subscription-ends-on',
    fallbackValue: 'Subscription ends on',
  },
  CANCEL_DAYS_LEFT: {
    languagePackKey: 'pages.cancel.days-left',
    fallbackValue: 'DAYS LEFT:',
  },
  CANCEL_PLAN_NAME: {
    languagePackKey: 'pages.cancel.plan-name',
    fallbackValue: 'Name',
  },
  CANCEL_PLAN_TYPE: {
    languagePackKey: 'pages.cancel.plan-type',
    fallbackValue: 'Type',
  },
  CANCEL_PLAN_PRICE: {
    languagePackKey: 'pages.cancel.plan-price',
    fallbackValue: 'Price',
  },
  CANCEL_PLAN_PERIOD: {
    languagePackKey: 'pages.cancel.plan-period',
    fallbackValue: 'Period',
  },
  CANCEL_PLAN_NEXT_BILLING: {
    languagePackKey: 'pages.cancel.plan-next-billing',
    fallbackValue: 'Next Billing',
  },
  CANCEL_PLAN_FREQUENCY: {
    languagePackKey: 'pages.cancel.plan-frequency',
    fallbackValue: 'Frequency',
  },
  CANCEL_CANCELLED: {
    languagePackKey: 'pages.cancel.cancelled',
    fallbackValue: 'Cancelled',
  },
  CANCEL_CONTINUE_SUBSCRIPTION: {
    languagePackKey: 'pages.cancel.continue-subscription',
    fallbackValue: 'Continue Subscription',
  },
  CANCEL_UNTIL_CANCELLED: {
    languagePackKey: 'pages.cancel.until-cancelled',
    fallbackValue: 'Until Cancelled',
  },
  CANCEL_STATUS_DRAFT: {
    languagePackKey: 'pages.cancel.status-draft',
    fallbackValue: 'Draft',
  },
  CANCEL_STATUS_PENDING_ACTIVATION: {
    languagePackKey: 'pages.cancel.status-pending-activation',
    fallbackValue: 'Pending Activation',
  },
  CANCEL_STATUS_PENDING_ACCEPTANCE: {
    languagePackKey: 'pages.cancel.status-pending-acceptance',
    fallbackValue: 'Pending Acceptance',
  },
  CANCEL_STATUS_ACTIVE: {
    languagePackKey: 'pages.cancel.status-active',
    fallbackValue: 'Active',
  },
  CANCEL_STATUS_CANCELLED: {
    languagePackKey: 'pages.cancel.status-cancelled',
    fallbackValue: 'Cancelled',
  },
  CANCEL_STATUS_EXPIRED: {
    languagePackKey: 'pages.cancel.status-expired',
    fallbackValue: 'Expired',
  },
  CANCEL_STATUS_SUSPENDED: {
    languagePackKey: 'pages.cancel.status-suspended',
    fallbackValue: 'Suspended',
  },
  CANCEL_STATUS_UNKNOWN: {
    languagePackKey: 'pages.cancel.status-unknown',
    fallbackValue: 'Unknown',
  },
  CANCEL_SUCCESS: {
    languagePackKey: 'pages.cancel.success',
    fallbackValue: 'You\'ve cancelled your subscription',
  },
  CANCEL_SUBSCRIPTION_WILL_END_ON: {
    languagePackKey: 'pages.cancel.subscription-will-end-on',
    fallbackValue: 'Your subscription will end on',
  },
  CANCEL_BACK_TO_SUBSCRIPTIONS: {
    languagePackKey: 'pages.cancel.back-to-subscriptions',
    fallbackValue: 'Back to Subscriptions',
  },
  CANCEL_SUBSCRIPTION_STATUS: {
    languagePackKey: 'pages.cancel.subscription-status',
    fallbackValue: 'Subscription Status',
  },
  CANCEL_CANCELLED_ON: {
    languagePackKey: 'pages.cancel.cancelled-on',
    fallbackValue: 'Cancelled on',
  },
  COMMON_DATE_TIME_FORMAT_LOCALE: {
    languagePackKey: 'pages.common.date-time-format-locale',
    fallbackValue: 'en-UK',
  },
  COMMON_CONFIRMATION_MODAL_CANCEL_BUTTON: {
    languagePackKey: 'pages.common.confirmation-modal-cancel-button',
    fallbackValue: 'Cancel',
  },
  COMMON_CONFIRMATION_MODAL_CONFIRM_BUTTON: {
    languagePackKey: 'pages.common.confirmation-modal-confirm-button',
    fallbackValue: 'Confirm',
  },
  COMMON_CONFIRMATION_MODAL_PRIMARY_ERROR_MESSAGE: {
    languagePackKey: 'pages.common.confirmation-primary-error-message',
    fallbackValue: 'Something went wrong!',
  },
  COMMON_CONFIRMATION_MODAL_SECONDARY_ERROR_MESSAGE: {
    languagePackKey: 'pages.common.confirmation-secondary-error-message',
    fallbackValue: 'Try again later.',
  },
  COMMON_NO_ACCESS_TITLE: {
    languagePackKey: 'pages.common.no-access-title',
    fallbackValue: 'No access.',
  },
  COMMON_NO_ACCESS_BODY: {
    languagePackKey: 'pages.common.no-access-body',
    fallbackValue: 'Sorry, you are not allowed to access this page. Click the button to go back.',
  },
  COMMON_NO_ACCESS_BACK_LINK: {
    languagePackKey: 'pages.common.no-access-back-link',
    fallbackValue: 'Go Back',
  },
  COMMON_PASSWORD_SHOW: {
    languagePackKey: 'pages.common.password-show',
    fallbackValue: 'Show',
  },
  COMMON_PASSWORD_HIDE: {
    languagePackKey: 'pages.common.password-hide',
    fallbackValue: 'Hide',
  },
  COMMON_INPUT_ERRORS_MISSING_VALUE: {
    languagePackKey: 'pages.common.input-errors-missing-value',
    fallbackValue: 'Please enter a value',
  },
  COMMON_INPUT_ERRORS_INVALID_URL: {
    languagePackKey: 'pages.common.input-errors-invalid-url',
    fallbackValue: 'Please enter a valid URL',
  },
  COMMON_INPUT_ERRORS_INVALID_EMAIL: {
    languagePackKey: 'pages.common.input-errors-invalid-email',
    fallbackValue: 'Please enter a valid email',
  },
  COMMON_COLLAPSIBLE_CONTENT_TEXT: {
    languagePackKey: 'pages.common.collapsible-content-text',
    fallbackValue: 'See details',
  },
};

export default LanguagePackEntries;
